if (!customElements.get('animated-text-component')) {
  class AnimatedTextComponent extends HTMLElement {
    constructor() {
      super();
      this.words = this.querySelectorAll('.animated-text__word');
      this.dynamicContainer = this.querySelector('.animated-text__dynamic');
      this.currentIndex = 0;
      this.interval = null;
      this.speed = parseInt(this.dataset.speed, 10) * 1000 || 3000;
    }

    connectedCallback() {
      if (this.words.length <= 1) return;

      // Set the dynamic container width to the widest word
      this.setContainerSize();
      window.addEventListener('resize', this.setContainerSize.bind(this));

      // Respect prefers-reduced-motion
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (prefersReducedMotion.matches) return;

      this.startRotation();

      // Pause on hover for accessibility
      this.addEventListener('mouseenter', () => this.stopRotation());
      this.addEventListener('mouseleave', () => this.startRotation());
    }

    disconnectedCallback() {
      this.stopRotation();
      window.removeEventListener('resize', this.setContainerSize.bind(this));
    }

    setContainerSize() {
      if (!this.dynamicContainer || this.words.length === 0) return;

      let maxWidth = 0;
      let maxHeight = 0;

      this.words.forEach((word) => {
        // Temporarily make visible to measure
        const wasActive = word.classList.contains('animated-text__word--active');
        word.style.position = 'relative';
        word.style.opacity = '1';
        word.style.transform = 'none';

        const rect = word.getBoundingClientRect();
        maxWidth = Math.max(maxWidth, rect.width);
        maxHeight = Math.max(maxHeight, rect.height);

        // Restore
        if (!wasActive) {
          word.style.position = '';
          word.style.opacity = '';
          word.style.transform = '';
        } else {
          word.style.position = '';
          word.style.opacity = '';
          word.style.transform = '';
        }
      });

      this.dynamicContainer.style.width = `${maxWidth}px`;
      this.dynamicContainer.style.height = `${maxHeight}px`;
    }

    startRotation() {
      if (this.interval) return;
      this.interval = setInterval(() => this.nextWord(), this.speed);
    }

    stopRotation() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    nextWord() {
      const current = this.words[this.currentIndex];
      const nextIndex = (this.currentIndex + 1) % this.words.length;
      const next = this.words[nextIndex];

      // Exit current word
      current.classList.remove('animated-text__word--active');
      current.classList.add('animated-text__word--exit');

      // Enter next word
      next.classList.add('animated-text__word--active');
      next.classList.remove('animated-text__word--exit');

      // Clean up exit class after transition
      setTimeout(() => {
        current.classList.remove('animated-text__word--exit');
      }, 500);

      this.currentIndex = nextIndex;
    }
  }

  customElements.define('animated-text-component', AnimatedTextComponent);
}
